import { useBuy } from "@/context/buy";
import { useEffect, useState } from "react";
import { formatShortDateTime } from "@/Utils/dateFormat";

export default function CustomTicketLinkModal() {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false)
    const { customModalData, setCustomModalData, setOpenModal } = useBuy();
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        fetchShowData()
    }, [])

    const fetchShowData = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("action", "getShowDetail");
            formData.append("show_id", customModalData.showId);

            const response = await fetch(
                `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageShow`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            const data = await response.json();

            if (data.status) {
                const values = data.data;
                setData(values);
            }
        } catch (error) {
            console.error("Error fetching show data:", error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };

    const fomatDate = (show_date, show_time) => {
        return formatShortDateTime(show_date, show_time);
    };

    return (
        <div id="ticket-modal" className="bg-gray-800 relative z-[9999999999999]">
            <div
                className="flex flex-col md:flex-row justify-start lg:items-center lg:justify-center fixed overflow-y-auto h-full inset-0 px-6 md:px-0 bg-gray-700/50 z-[999]"
                onClick={() => {
                    setOpenModal(false)
                    setCustomModalData({
                        showId: '',
                        link: ''
                    })
                }}
            >
                {loading ? (
                    <div className="bg-[#1F222A] min-h-[616px] lg:w-[620px] lg:max-w-[620px] relative mt-5 flex justify-center items-center lg:bg-[#1F222A] h-fit w-full  md:mt-[50px] lg:mb-[50px] py-[36px] px-[18px] lg:p-12 rounded-lg md:w-1/3 ">
                        <div className="md:hidden" onClick={(e) => {
                            setOpenModal(false)
                            setCustomModalData({
                                showId: '',
                                link: ''
                            })
                        }}>
                            <div className="flex justify-end  mt-3 -mr-5">
                                <div
                                    className=" w-10 h-10 rounded-full bg-[#1F222A] flex  items-center justify-center mb-2 "
                                >
                                    <svg
                                        width="13"
                                        height="12"
                                        viewBox="0 0 13 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0.144 12L5.496 5.352V6.552L0.456 0.287999H3.288L6.864 4.848H6L9.576 0.287999H12.408L7.368 6.504V5.424L12.72 12H9.84L6 7.152H6.816L3 12H0.144Z"
                                            fill="#6A798F"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="loader"></div>
                    </div>
                ) : (
                    <>
                        <div className="md:hidden" onClick={(e) => {
                            setOpenModal(false)
                            setCustomModalData({
                                showId: '',
                                link: ''
                            })
                        }}>
                            <div className="flex justify-end  mt-3 -mr-5">
                                <div
                                    className=" w-10 h-10 rounded-full bg-[#1F222A] flex  items-center justify-center mb-2 "
                                >
                                    <svg
                                        width="13"
                                        height="12"
                                        viewBox="0 0 13 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0.144 12L5.496 5.352V6.552L0.456 0.287999H3.288L6.864 4.848H6L9.576 0.287999H12.408L7.368 6.504V5.424L12.72 12H9.84L6 7.152H6.816L3 12H0.144Z"
                                            fill="#6A798F"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div
                            id=""
                            className="bg-[#17191d] h-fit w-full max-w-[620px] overflow-hidden md:my-[20px] overflow-y-auto px-4 lg:px-[40px] pb-[40px]  rounded-[16px] lg:rounded-2xl "
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className=" pb-5 lg:pb-10 pt-10 lg:pt-16 text-xl lg:text-2xl font-semibold  ">{"Heads Up! You're leaving Qoncert"}</div>
                            <div className="mt-6 lg:mt-0">
                                <div className="ticket-card">
                                    <div className="flex gap-4 h-full">
                                        <div className="ticket-main-image min-w-[120px] ">
                                            <img src={data?.banner} alt="" />
                                        </div>
                                        <div className="flex flex-col pt-5 gap-4 h-full">
                                            <p className="modal-header urbanist">{data?.name}</p>
                                            <p className="modal-date  urbanist">
                                                {fomatDate(data?.show_date, data?.show_time)}
                                            </p>
                                            <div className="modal-location urbanist">
                                                <svg
                                                    width="16"
                                                    height="17"
                                                    viewBox="0 0 16 17"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M2.33301 7.823C2.33301 4.75643 4.8956 2.27783 7.99531 2.27783C11.1038 2.27783 13.6663 4.75643 13.6663 7.823C13.6663 9.36829 13.1043 10.8029 12.1793 12.0189C11.1589 13.3602 9.90111 14.5288 8.48537 15.4461C8.16135 15.6581 7.86892 15.6741 7.51331 15.4461C6.0895 14.5288 4.83173 13.3602 3.82001 12.0189C2.89433 10.8029 2.33301 9.36829 2.33301 7.823ZM6.12916 7.99567C6.12916 9.02297 6.96745 9.83095 7.9953 9.83095C9.02384 9.83095 9.87019 9.02297 9.87019 7.99567C9.87019 6.97636 9.02384 6.12905 7.9953 6.12905C6.96745 6.12905 6.12916 6.97636 6.12916 7.99567Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                                <span className="modal-date">
                                                    {data?.venue?.name}, {data?.venue?.city},{" "}
                                                    {data?.venue?.state}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-6 text-base lg:text-lg font-bold ">
                                This Show is being ticketed through the venue
                                <span
                                    className="relative inline-block ml-2"
                                    onMouseEnter={() => setShowTooltip(true)}
                                    onMouseLeave={() => setShowTooltip(false)}
                                >
                                    <div className="w-5 h-5 rounded-full border border-white inline-flex items-center justify-center cursor-pointer">
                                        <span className="text-xs">i</span>
                                    </div>
                                    {showTooltip && (
                                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-fit bg-gray-800 text-white text-sm p-2 rounded shadow-lg z-10">
                                            <div className="text-xs min-w-max font-normal whitespace-normal">
                                                <p>Some venues require </p>
                                                <p>we use their ticketing.</p>
                                                <p>Fees may be applied.</p>
                                            </div>
                                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-8 border-solid border-transparent border-t-gray-800"></div>
                                        </div>
                                    )}
                                </span>
                            </div>
                            <div className="mt-11 text-base lg:text-lg ">{"Don't worry--you're still supporting the artist"}</div>
                            <div className="mt-2 text-base lg:text-lg">Just make sure to come back an grab your next show here!</div>
                            {/* seperato */}
                            <div className="h-12"></div>
                            <div className="w-full border border-[#212121]"></div>
                            <div
                                className={`mt-5 lg:mt-8 modal-footer flex flex-col lg:flex-row gap-4 lg:gap-8 items-center justify-end`}
                            >
                                <button
                                    className={`border-[#35383F] hidden lg:block bg-[#6b6b6b17] font-urbanist font-[500] border text-[14px] lg:text-base py-[6px] lg:py-[19px] lg:leading-[10px] w-[180px] px-[62px] lg:w-[340px] rounded-[10px]  `}
                                    onClick={() => {
                                        setOpenModal(false)
                                        setCustomModalData({
                                            showId: '',
                                            link: ''
                                        })
                                    }}
                                >
                                    {" "}
                                    Cancel
                                </button>
                                <button
                                    className={`main_btn_bg min-w-max font-urbanist lg:order-2 font-[800] text-[14px]  lg:text-base py-[6px] lg:py-5 px-[62px] w-full lg:w-[340px] rounded-[10px] lg:leading-[10px] `}
                                    onClick={() => {
                                        window.open(customModalData.link, '_blank')
                                    }}
                                >
                                    {" "}
                                    Continue to Tickets
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}